import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mic, Sparkles } from 'lucide-react';
import { Button } from '@mellify/ui';
import { ROUTES } from '../../routes/routeConfig';
import { AIGenerateBrandVoiceModal } from './brand-voice/components/AIGenerateBrandVoiceModal';

/**
 * BrandVoicePageActions
 *
 * Rendered in the DashboardLayout page header for the Brand Voice page.
 * Links to the brand voice create form and AI generation modal.
 */
export const BrandVoicePageActions: React.FC = () => {
  const navigate = useNavigate();
  const [showAIGenerateModal, setShowAIGenerateModal] = useState(false);

  return (
    <>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          leftIcon={<Sparkles className="w-4 h-4" />}
          onClick={() => setShowAIGenerateModal(true)}
        >
          AI Generate
        </Button>
        <Button
          variant="primary"
          size="sm"
          leftIcon={<Mic className="w-4 h-4" />}
          onClick={() => navigate(ROUTES.DASHBOARD_BRAND_VOICE_NEW)}
        >
          Create Brand Voice
        </Button>
      </div>

      <AIGenerateBrandVoiceModal
        open={showAIGenerateModal}
        onClose={() => setShowAIGenerateModal(false)}
      />
    </>
  );
};

BrandVoicePageActions.displayName = 'BrandVoicePageActions';